import { StrictMode, useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles.css";

function RoutedApp() {
  const [, render] = useState(0);
  useEffect(() => {
    const rerender = () => render((value) => value + 1);
    window.addEventListener("popstate", rerender);
    return () => window.removeEventListener("popstate", rerender);
  }, []);
  return <App />;
}

createRoot(document.getElementById("root")!).render(<StrictMode><RoutedApp /></StrictMode>);

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((registration) => registration.update())
      .catch(() => undefined);
  });
}
